export default __webpack_public_path__ + "static/creditCard-37e1342a1d8e32e48ea5d4345f18ea04.png";